export default {
  smartSection: {
    title: {
      fr: "Des espaces qui vous ressemblent.",
      en: "Spaces designed around your lifestyle.",
    },
    subtitle: {
      fr: "Eclairages, Chauffage, Volets...",
      en: "Lighting, Heating, Blinds.",
    },
    features: {
      title: {
        fr: "",
        en: "",
      },
      items: {
        groups: {
          title: {
            fr: "D’une pierre, mille coups.",
            en: "Do more with a single action.",
          },
          subtitle: {
            fr: "",
            en: "",
          },
          description: {
            fr: "Regroupez vos éclairages, et commandez les d’un seul geste.\nLe groupe est un outil très pratique pour contrôler un\n ensemble d’équipements de même nature.",
            en: "Group your lights and control them with a single action.\nGroups make it easy to control multiple\n devices of the same type.",
          },
        },

        automation: {
          title: {
            fr: "Créez les automatismes de votre quotidien.",
            en: "Automate your daily routines.",
          },
          description: {
            fr: "Selon vos conditions, le système éxécutera vos souhaits de façon autonome même sans Internet.",
            en: "Based on your conditions, the system automatically takes action on your behalf even without Internet.",
          },
          operatorWhen: {
            fr: "LORSQUE",
            en: "WHEN",
          },
          operatorIf: {
            fr: "SI",
            en: "IF",
          },
          operatorAnd: {
            fr: "ET",
            en: "AND",
          },
          operatorOr: {
            fr: "OU",
            en: "OR",
          },
          operatorThen: {
            fr: "ALORS",
            en: "THEN",
          },
          automation1: {
            when: {
              title: {
                fr: "Condition heure & jour",
                en: "Day and time condition",
              },
              subtitle: {
                fr: "La semaine entre 8h et 18h",
                en: "Week days from 8am to 6pm",
              },
            },
            if: {
              title: {
                fr: "Capteur de mouvement",
                en: "Motion sensor",
              },
              subtitle: {
                fr: "Une présence est detectée",
                en: "Occupacy detected",
              },
            },
            or: {
              title: {
                fr: "Capteur d'ouverture",
                en: "Open sensor",
              },
              subtitle: {
                fr: "La porte est ouverte",
                en: "The door is open",
              },
            },
            then: {
              title: {
                fr: "Notification",
                en: "Notification",
              },
              subtitle: {
                fr: "Alerte présence",
                en: "Presence detection alert",
              },
            },
          },
          automation2: {
            when: {
              title: {
                fr: "Condition heure & jour",
                en: "Day and time condition",
              },
              subtitle: {
                fr: "A partir de 18h00",
                en: "at 6pm",
              },
            },
            if: {
              title: {
                fr: "Capteur de mouvement",
                en: "Motion sensor",
              },
              subtitle: {
                fr: "J'arrive dans le salon",
                en: "Occupacy detected",
              },
            },
            or: {
              title: {
                fr: "Capteur de luminosité",
                en: "Light sensor",
              },
              subtitle: {
                fr: "Il fait sombre",
                en: "It's dark",
              },
            },
            then: {
              title: {
                fr: "Action de type On",
                en: "On action",
              },
              subtitle: {
                fr: "Eclairer le salon",
                en: "Light on in the living room",
              },
            },
          },
        },

        scenes: {
          title: {
            fr: "Des scénarios pour toutes les situations.",
            en: "Smart scenes for every moment.",
          },
          subtitle: {
            fr: "Quand je pars, j’éteins les éclairages, je baisse le chauffage et je ferme les volets.",
            en: "When I leave, lights turn off, heating is lowered, and shutters close.",
          },
          description: {
            fr: "Un scénario permet de contrôler un ensemble d’équipements variés dans un état prédéfini.\nDéclenchez également vos scènes favorites avec un interrupteur mural.",
            en: "A scene lets you control multiple types of devices in a predefined state. You can also trigger your favorite scenes using a physical switch.",
          },
        },
      },
    },
  },
};
